angular.module('bmsApp.sm.quote', [
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.sm.quote', {
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/sm/quote/templates/QuoteMain.html',
							controller: 'SMQuoteMainCtrl'
						}
					}
				})

				.state('main.sm.quote.index', {
					url: '^/sm/quotes',
					views: {
						'content@main.sm.quote': {
							templateUrl: 'ng/sm/quote/templates/QuoteIndex.html',
							controller: 'SMQuoteIndexCtrl'
						},
						'side@main.sm.quote': {
							templateUrl: "ng/sm/quote/templates/QuoteIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Quotes'}
				})

				.state('main.sm.quote.index.create', {
					url: '^/sm/quote/add/{customerId}',
					views: {
						'content@main.sm.quote': {
							templateUrl: 'ng/sm/quote/templates/QuoteSave.html',
							controller: 'SMQuoteSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Add Quote'}
				})


				.state('main.sm.quote.index.view', {
					url: '^/sm/quote/view/{quoteId}',
					views: {
						'content@main.sm.quote': {
							templateUrl: 'ng/sm/quote/templates/QuoteView.html',
							controller: 'SMQuoteViewCtrl'
						}
					},
					ncyBreadcrumb: { label: "{{ quote.name }}" }
				})

				.state('main.sm.quote.index.view.update', {
					url: '^/sm/quote/edit/{quoteId}',
					views: {
						'content@main.sm.quote': {
							templateUrl: 'ng/sm/quote/templates/QuoteSave.html',
							controller: 'SMQuoteSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Edit Quote'}
				})

				.state('main.sm.quote.index.view.convert', {
					url: '^/sm/quote/convert/{quoteId}',
					views: {
						'content@main.sm.quote': {
							templateUrl: 'ng/sm/job/templates/JobSave.html',
							controller: 'SMJobSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Convert Quote'}
				})
			;

		}]);
